import './LandCompanyPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import LandBottomLayout from '../common/LandBottomLayout'

export default class LandCompanyPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandCompanyPage">
          <div className="LandCompanyPageName">{'公司介绍'}</div>
          <div className="LandCompanyPageIntroduction">
            {
              '江苏凯士达阀门科技有限公司，是国内一家阀门创新型企业，专注于高端仪表管阀件的研发、生产和销售。公司总部位于江苏省，凭借创新的技术、精湛的工艺和卓越的服务，迅速在国内外细分阀门领域中占据了一席之地。江苏凯士达阀门科技有限公司在危化品运输、半导体行业和氢能领域，拥有独特的市场优势和领先的技术水平，致力于为全球客户提供更高效、更安全、更环保的解决方案。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            {
              '公司产品广泛应用于槽罐车、氢能、半导体、化工、精细化工、医药卫生、食品饮料、酿造、石油储存、油品提炼、电力、冶金、水处理、气体处理、矿业等多个领域，涉及的产品包括但不限于高性能阀门、管件、仪表控制设备及系统。我们的产品在确保密封性、安全性和可靠性的基础上，优化了设计，提升了使用寿命，符合国际领先的质量标准。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>核心竞争力</span>
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>技术创新：</span>
            {
              '江苏凯士达坚持技术研发，拥有一支由经验丰富的工程师和技术专家组成的研发团队，持续推动阀门产品的技术创新和应用研究。公司与多家国内外科研院所及高校建立了长期合作关系，确保技术始终处于行业领先地位。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>品质保障：</span>
            {
              '公司拥有现代化的生产线和高精密的加工设备，所有产品均通过严格的质量检验程序，确保每一件产品都达到国际一流的质量标准。公司具备多项行业认证，产品已广泛应用于国内外市场，并获得客户的广泛赞誉。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>行业应用：</span>
            {
              '在危化品运输、半导体行业和氢能领域，凯士达阀门凭借其卓越的技术和产品质量，赢得了诸多行业领导企业的认可。我们的阀门 产品被广泛应用于石油化工、精细化工、天然气、制药、食品饮料、冶金、矿山等重要行业。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>全球布局：</span>
            {
              '公司积极拓展国际市场，产品出口到欧美、东南亚、中东等多个国家和地区，建立了稳定的全球销售网络和完善的售后服务体系。'
            }
          </div>
          <div className="LandCompanyPageIntroduction">
            <span style={{ fontWeight: 'bold' }}>愿景与使命</span>
          </div>
          <div className="LandCompanyPageIntroduction">
            {
              '江苏凯士达阀门科技有限公司始终秉持“精工细作，安全可靠”的理念，不断超越自我，持续创新，以为全球用户提供高质量、高性能的阀门产品为己任。未来，公司将继续致力于为各行业提供一流的管阀解决方案，并推动行业发展，为全球阀门产业的进步贡献力量。'
            }
          </div>
          <div style={{ height: 50 }} />
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }
}
